const state = {
    test: ''
}
const mutations = {
    CHANGE_TEST_VALUE: (state, view) => {
        state.test = view
    }
}
const actions = {
    //修改调用 this.$store.dispatch("vuexTest/changeTestValue",v)
    //获取vuex值this.$store.state.vuexTest.test
    changeTestValue({ commit }, view) {
        commit('CHANGE_TEST_VALUE', view)
    }
}

export default {
    state,
    namespaced: true,
    mutations,
    actions
}
